import { useQuery } from '@tanstack/react-query';
import {
  RouteResource,
  ShiftPlanningIssueResource,
  ShiftResource,
  shiftsGetIssues,
  TurnPlanningIssueResource,
  TurnResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

type CustomTurnResource = Omit<
  TurnResource,
  'id' | 'route' | 'turnAssignments'
> & {
  id: number;
  route: RouteResource;
  turnAssignments: number[];
};

export const useShiftIssues = (args: { id: number; expand?: string[] }) =>
  useQuery({
    queryFn: () =>
      extractData(
        shiftsGetIssues({
          path: { id: args.id },
          query: { expand: args.expand },
        })
      ) as unknown as {
        shift: Omit<
          ShiftResource,
          'id' | 'applicationState' | 'assignmentState' | 'turns'
        > & {
          id: number;
          applicationState: string;
          assignmentState: string;
          turns: Array<CustomTurnResource>;
        };
        shiftPlanningIssues?: Array<ShiftPlanningIssueResource> | null;
        issues: Array<{
          turn: CustomTurnResource;
          issues: Array<TurnPlanningIssueResource>;
        }>;
      },
    queryKey: ['shifts', args.id, 'issues', args.expand],
    // ponytail: poll to match the calendar's live updates (WeekplanLayout also
    // refetches every 1000ms); swap for push/invalidation if that ever lands.
    refetchInterval: 1000,
  });
